module.exports = __webpack_public_path__ + "static/media/repository.c470a697.svg";